var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ReadMeView"}},[_c('div',{staticClass:"about"},[_c('vue-markdown',{attrs:{"source":_vm.md_source === '0' ? _vm.md_firmware : _vm.md_driver}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }